var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentStatus && _vm.currentStatus !== _vm.statusName.not_set)?_c('span',{staticClass:"status text-xs font-medium rounded-lg tracking-wide inline-block px-2 py-1",style:({
    'color': _vm.currentColor,
    'background-color': _vm.hexToRgba(_vm.currentColor, 0.1)
  })},[_vm._v(_vm._s(_vm.currentStatus))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }